const getOptionValue = (option) => {
  return `${option.id}`;
};

export default getOptionValue;
